import React from 'react';
import { useTranslation } from 'react-i18next';
import mnFlag from '../../assets/flags/mn.svg';
import kzFlag from '../../assets/flags/kz.svg';
import uzFlag from '../../assets/flags/uz.svg';
import jpFlag from '../../assets/flags/jp.svg';
import krFlag from '../../assets/flags/kr.svg';

/**
 * Customer-proof band: languages we have trained production models in.
 * Flag SVGs are vendored from the MIT-licensed flag-icons set (real icons,
 * not emoji, per design requirement).
 */
const TRAINED_LANGUAGES = [
  { key: 'mn', flag: mnFlag },
  { key: 'kk', flag: kzFlag },
  { key: 'uz', flag: uzFlag },
  { key: 'ja', flag: jpFlag },
  { key: 'ko', flag: krFlag },
] as const;

const LanguagesBand: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="lab-languages" className="relative z-10 px-4 py-12 md:px-[72px]">
      <div className="mx-auto w-full max-w-[880px] text-center [text-shadow:0_2px_30px_rgba(0,0,0,0.5)]">
        <div className="font-plexmono text-[11.5px] tracking-[0.18em] text-lab-tts">
          {t('lab.languages.kicker')}
        </div>
        <h2 className="mt-5 text-[clamp(26px,4.5vw,38px)] font-semibold leading-[1.15] tracking-[-0.02em] [text-wrap:balance]">
          {t('lab.languages.title')}
        </h2>
        <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.7] text-lab-frost/70 md:text-[15.5px]">
          {t('lab.languages.desc')}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {TRAINED_LANGUAGES.map(({ key, flag }) => (
            <div
              key={key}
              className="lab-siri flex items-center gap-2.5 rounded-full border border-lab-frost/20 bg-white/[0.03] px-4 py-2"
            >
              <img
                src={flag}
                alt=""
                className="h-[18px] w-6 rounded-[2px] object-cover shadow-[0_1px_4px_rgba(0,0,0,0.4)]"
              />
              <span className="text-[13.5px] text-lab-frost/85">{t(`lab.languages.names.${key}`)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LanguagesBand;
